import { Fetch } from '.';
import { AppUser } from '../components/App/appReducer';
import { Metadata } from '../types';

export interface UserInfo {
  info: AppUser;
}

export const getUser = (f: Fetch) => async (): Promise<UserInfo> => {
  const r = await f.getJSON<Metadata>('/admin/user/info');
  if (r) {
    let { roles, employeeId, firstName, lastName, userId, email } = r as any;
    if (typeof roles == 'string') {
      roles = roles.split(',');
    }
    if (typeof employeeId == 'string') {
      employeeId = parseInt(employeeId);
    }
    const jobRoles = r.props?.jobRoles;

    return {
      info: { roles, employeeId, firstName, lastName, userId, email, jobRoles }
    };
  }
  console.error('getUser', r);
  throw new Error('Failed to get user');
};
